import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ApiService } from './api.service';
import { AuthService } from './auth.service';
@Component({
  selector: 'app-assistant-dashboard',
  templateUrl: './assistant-dashboard.component.html',
  styleUrls: ['./shared.css']
})
export class AssistantDashboardComponent implements OnInit {
  query = '';
  patients: any[] = [];
  doctors: any[] = [];
  selected: any = null;
  form: any = {};
  investigationResult = '';
  resultStatus = 'pending';
  constructor(public auth: AuthService, private api: ApiService, private router: Router) {}
  ngOnInit(): void { this.search(); this.api.getDoctors().subscribe((res: any) => this.doctors = res?.data || []); }
  search(): void { this.api.getPatients(this.query).subscribe((res: any) => this.patients = res?.data || []); }
  select(p: any): void { this.selected = p; this.form = { ...p }; }
  savePatient(): void { this.api.savePatient(this.form).subscribe(() => this.search()); }
  deletePatient(p: any): void { this.api.deletePatient(p.id).subscribe(() => this.search()); }
  saveInvestigationResult(): void { if (this.selected) this.api.saveInvestigationResult({ patient_id: this.selected.id, result_text: this.investigationResult, status: this.resultStatus }).subscribe(); }
  logout(): void { this.auth.logout(); this.router.navigate(['/login']); }
}
